<template>
	<section :id="data.id" class="hero" :hero-size="hero.size">
		<div class="hero-content">
			<div class="container">
				<h1 class="heading" v-if="hero.title" v-html="sanitizeTitle(hero.title)"></h1>
				<h2 class="heading" v-if="hero.subtitle && typeof hero.subtitle === 'string'" v-html="sanitizeTitle(hero.subtitle)"></h2>

				<RichText v-if="hero?.text" :content="hero.text.content" />
				<Button v-if="hero?.cta" v-on:click="scroll" :data="hero?.cta?.fields"/>
			</div>
		</div>
		<div class="hero-background-image">
			<img src="~/assets/images/home-hero-angular-gradient-wide.svg" alt="Hero background image" width="2000" height="1136" />
		</div>
	</section>
</template>

<script setup>
import {useSanitize} from "~~/composables/useSanitize.js";
import scrollTo from './client/Hero.js';
const { sanitizeTitle } = useSanitize();
const  { data } = defineProps({
	data: {
		type: Object,
		required: true
	}
});

const { $velocity } = useNuxtApp();

const hero = computed(() => data?.data ?? {});
const heroCtaScrollToID = computed(() => {
	return hero?.value?.cta?.fields?.url;
});
const scroll = (event) => {
	if (process.client) {
		const scrollID = heroCtaScrollToID.value.replace('#', '');

		scrollTo($velocity, scrollID, -140);
	}
};
</script>

<style lang="scss">
@use '~/assets/scss/components/Hero.scss';
</style>